
const WhatIsPACTSectionV4 = () => {
  const examples = [
    {
      action: "read 10 pages",
      duration: "21 days",
      mockup: (
        <div className="bg-white rounded-xl p-4 shadow-lg border border-purple-100">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm">📖</div>
            <div>
              <p className="font-bold text-gray-900 text-sm">Read 10 pages</p>
              <p className="text-gray-600 text-xs">Day 5 of 21</p>
            </div>
          </div>
          <div className="bg-purple-600 h-2 rounded-full">
            <div className="bg-yellow-400 h-2 rounded-full w-1/4"></div>
          </div>
        </div>
      )
    },
    {
      action: "walk 15 minutes",
      duration: "14 days",
      mockup: (
        <div className="bg-white rounded-xl p-4 shadow-lg border border-purple-100">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm">🚶</div>
            <div>
              <p className="font-bold text-gray-900 text-sm">Walk 15 minutes</p>
              <p className="text-gray-600 text-xs">Day 8 of 14</p>
            </div>
          </div>
          <div className="bg-purple-600 h-2 rounded-full">
            <div className="bg-yellow-400 h-2 rounded-full w-3/5"></div>
          </div>
        </div>
      )
    },
    {
      action: "meditate 5 minutes",
      duration: "30 days",
      mockup: (
        <div className="bg-white rounded-xl p-4 shadow-lg border border-purple-100">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm">🧘</div>
            <div>
              <p className="font-bold text-gray-900 text-sm">Meditate 5 minutes</p>
              <p className="text-gray-600 text-xs">Day 12 of 30</p>
            </div>
          </div>
          <div className="bg-purple-600 h-2 rounded-full">
            <div className="bg-yellow-400 h-2 rounded-full w-2/5"></div>
          </div>
        </div>
      )
    }
  ];

  const framework = [
    {
      letter: "P",
      word: "Purposeful",
      description: "Meaningful for your learning journey"
    },
    {
      letter: "A",
      word: "Actionable",
      description: "Doable with your current resources"
    },
    {
      letter: "C",
      word: "Continuous",
      description: "Simple and repeatable"
    },
    {
      letter: "T",
      word: "Trackable",
      description: "Binary tracking (Yes or No)"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-purple-50 to-indigo-50 relative overflow-hidden">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight">
            What's a
            <span className="block text-purple-600">PACT?</span>
          </h2>
          <p className="text-2xl text-gray-700 font-medium">
            Simple commitments that actually end
          </p>
        </div>

        {/* PACT Formula */}
        <div className="bg-white rounded-3xl p-12 shadow-xl border border-purple-100 mb-16">
          <h3 className="text-3xl font-black text-center text-gray-900 mb-8">
            The PACT Formula
          </h3>
          <div className="text-center">
            <p className="text-4xl md:text-5xl font-black text-purple-600 leading-relaxed">
              I will <span className="text-yellow-500">[action]</span> for <span className="text-purple-600">[duration]</span>
            </p>
          </div>
        </div>

        {/* Visual Examples */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {examples.map((example, index) => (
            <div key={index} className="text-center">
              <div className="mb-6">
                {example.mockup}
              </div>
              <p className="text-xl font-bold text-gray-900">
                "I will <span className="text-yellow-500">{example.action}</span> for <span className="text-purple-600">{example.duration}</span>"
              </p>
            </div>
          ))}
        </div>

        {/* PACT Framework */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-3xl p-12 text-white">
          <h3 className="text-3xl font-black text-center mb-12">
            PACT Framework
          </h3>
          <div className="grid md:grid-cols-4 gap-8">
            {framework.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-yellow-400 text-purple-900 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-black">{item.letter}</span>
                </div>
                <h4 className="text-xl font-black mb-2">{item.word}</h4>
                <p className="text-white/90 font-medium">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsPACTSectionV4;
